import Calculations from '@/views/Calculations/Index'
import CalculationsCalculations from '@/views/Calculations/Calculations/Index'
import CalculationsCalculation from '@/views/Calculations/Calculation/Index'
import CalculationsCalculationProduct from '@/views/Calculations/Calculation/Product/Index'

export default [
    {
        path: '/calculations',
        name: 'calculations',
        component: Calculations,
        meta: {
            title: 'Kalkulacje',
            menuRendered: true,
            menuTitle: 'Kalkulacje',
            permission: 'calculations',
            icon: 'mdi-currency-usd-circle',
        },
        redirect: { name: 'calculationsCalculations' },
        children: [
            {
                path: '/calculations/calculations',
                name: 'calculationsCalculations',
                component: CalculationsCalculations,
                meta: {
                    title: 'Kalkulacje / Lista kalkulacji',
                    menuTitle: 'Lista kalkulacji',
                    requiresAuth: true,
                    permission: 'calculations_read',
                },
            },
            {
                path: '/calculations/calculations/:id',
                name: 'calculationsCalculation',
                component: CalculationsCalculation,
                meta: {
                    title: 'Kalkulacje / Kalkulacja',
                    requiresAuth: true,
                    permission: 'calculations_create',
                },
            },
            {
                path: '/calculations/calculations/:id/add-product',
                name: 'calculationsCalculationAddProduct',
                component: CalculationsCalculationProduct,
                meta: {
                    title: 'Kalkulacje / Kalkulacja / Dodaj produkt',
                    requiresAuth: true,
                    permission: 'calculations_create',
                },
            },
            {
                path: '/calculations/calculations/:id/product/:productId',
                name: 'calculationsCalculationProduct',
                component: CalculationsCalculationProduct,
                meta: {
                    title: 'Kalkulacje / Kalkulacja / Produkt',
                    requiresAuth: true,
                    permission: 'calculations_create',
                },
            },
        ]
    }
]